import { createFeedbackStore } from "@bps/stores";
import { getErrorAlertMessage } from "@libs/api/types/error.utils";

export const useFeedbackContext = createFeedbackStore({
  parseError: getErrorAlertMessage
});
